import React from 'react';
import JustificationContainer, {
  Props as JustificationContainerProps,
} from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import type { ValidationError } from '~/components/page/LFA/state/validationState';

type Props = {
  error: ValidationError;
  margin?: JustificationContainerProps['margin'];
};

const ErrorBlock: React.FCC<Props> = ({
  error,
  margin = [null, null, 'xxxs', null],
}) => (
  <JustificationContainer
    backgroundColor={{ group: 'danger', variant: 'translucent' }}
    padding={['xxxs', 'xxs']}
    border={{ radius: 'base', width: 's', color: { group: 'danger' } }}
    margin={margin}
  >
    <Body
      margin={[null]}
      color={{ group: 'danger' }}
      size="base"
      fontWeight="semiBold"
    >
      {error.message}
    </Body>
  </JustificationContainer>
);

export default ErrorBlock;
